<template>
    <app-layout>
        <template #header>
            <div class="relative">
                <div class="absolute top-0 right-0">
                    <button
                        @click="print()"
                        class="bg-yellow-500 text-sm hover:bg-yellow-600 text-white text-base font-bold my-0 -mt-10 py-2 px-4 rounded">
                        <i class="fas fa-downloadmr-1 "></i>&nbsp;Download
                    </button>
                </div>
                <inertia-link class="font-semibold text-xl text-gray-800 leading-tight"
                    :href="route('extract.index')"
                >
                    <i class="fas fa-arrow-left mr-1"></i>
                    Comprovante de transação
                </inertia-link>
            </div>
        </template>

        <div class="pb-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 pt-10">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg px-4 py-4">
                    <receipt
                        class="mt-5 p-5 w-1/2 mx-auto"
                        :logo="logo"
                        :extract="extract"
                        :receipt="receipt"
                        :refund="refund"
                    />
                </div>
            </div>
        </div>
    </app-layout>
</template>
<script>
import AppLayout from './../../Layouts/AppLayout';
import Receipt from './Receipt.vue';
import Welcome from './../../Jetstream/Welcome';
import JetConfirmationModal from './../../Jetstream/ConfirmationModal';
import JetSecondaryButton from './../../Jetstream/SecondaryButton';
import JetOkButton from './../../Jetstream/OkButton';
import ApplicationMark from './../../Jetstream/ApplicationMark';
import Flash from "../../Helpers/Flash"
import InertiaTable from "../../Helpers/Tables/InertiaTable";
import TransferReceipt from '../Transfer/Receipt';
import BoletoReceipt from '../Boleto/Receipt';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export default {
    components: {
        AppLayout,
        Receipt,
        Flash,
        InertiaTable,
        TransferReceipt,
        BoletoReceipt,
        Welcome,
        JetConfirmationModal,
        JetSecondaryButton,
        JetOkButton,
        ApplicationMark
    },
    props: ['receipt', 'extract', 'errors', 'logo', 'refund'],
    methods: {
        show: function (item) {
            if (item.movement_type === 'D' && item.operation_code !== 'bank-fee' && row.item.operation_code !== 'maintenance'  && row.item.operation_code !== 'acquiring-charge-device') {
                this.search('receipts', item, this);
                this.$forceUpdate();
            }
        },
        parseDescription: function (item) {
            switch (item.description.split(' ')[0]) {
                case 'TED':
                    return 'ENVIO TED';
                case 'TRANSFERENCIA':
                    return 'ENTRE CONTAS ' + (item.movement_type == 'D' ? 'DÉBITO' : 'CRÉDITO');
                default:
                    return item.description;
            }
        },
        print() {
            html2canvas(document.querySelector('#transfer-receipt'), {dpi: 144, scale: 1}).then(canvas => {
                let imgData = canvas.toDataURL('image/png');
                let doc = new jsPDF();
                doc.addImage(imgData, 'PNG', 10, 10);
                doc.save('comprovante.pdf');
            });
        }
    }
}
</script>
